import React from "react";
import ReactDOM from "react-dom";
import PortalModal from "../common/portalModal";

// string constants for keypresses
const LEFT_ARROW_KEY = 37;
const RIGHT_ARROW_KEY = 39;
const ESC_KEY = 27;

class AlignmentSlider extends React.Component {
  constructor(props) {
    super(props);
    this._handleKeyPress = this._handleKeyPress.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this._handleKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyPress);
  }

  _handleKeyPress = e => {
    if (e.keyCode === LEFT_ARROW_KEY) {
      this.onPrevArrowClick();
    } else if (e.keyCode === RIGHT_ARROW_KEY) {
      this.onNextArrowClick();
    } else if (e.keyCode === ESC_KEY) {
      this.props.closeSlider();
    }
  };

  onNextArrowClick = () => {
    // shift data context to next member
    this.props.nextArrowClick();
    $('.portalWrapper').scrollTop(0);
  };

  onPrevArrowClick = () => {
    // shift data context to previous member
    this.props.prevArrowClick();
    $('.portalWrapper').scrollTop(0);
  };

  displaySliderNextArrow = () => {
    return (
      <div className="portalNextArrow portalArrows" data-testid="portalNextArrowportalArrows">
        <span
          className="icon icon-outline-arrow_forward_ios-24px cursor-pointer"
          onClick={this.onNextArrowClick}
        />
      </div>
    );
  };

  displaySliderPrevArrow = () => {
    return (
      <div className="portalPrevArrow portalArrows">
        <span
          className="icon icon-outline-arrow_back_ios-24px cursor-pointer"
          onClick={this.onPrevArrowClick}
        />
      </div>
    );
  };

  getLeftCount = (numMembers, numColumns) => {
    const halfCount = Math.floor(numMembers / numColumns);
    const remainderCount = Math.floor(numMembers % numColumns);

    return halfCount + remainderCount;
  };

  getRightCount = (numMembers, numColumns) => {
    // case of only 1 member to split - right side will always have zero
    if (numMembers === 1) {
      return 0;
    }

    return Math.floor(numMembers / numColumns);
  };

  getSubheaderMetricData = (columnContext, metrics) => {
    const leftCount = this.getLeftCount(metrics.length, 2);
    const rightCount = this.getRightCount(metrics.length, 2);

    if (columnContext === "left") {
      const leftData = metrics.filter((metric, index) => {
        return index < leftCount;
      });
      return leftData;
    } else {
      const rightData = metrics.filter((metric, index) => {
        return index > metrics.length - rightCount - 1;
      });
      return rightData;
    }
  };

  calculateTotalMetricCount = goals => {
    let totalCount = 0;
    if (goals && goals.length) {
      totalCount = goals.reduce((acc, goal) => {
        const accInt = isNaN(acc) ? 0 : parseInt(acc);
        const lengthInt = isNaN(goal.metrics.length)
          ? 0
          : parseInt(goal.metrics.length);
        return accInt + lengthInt;
      }, {});
    }

    return totalCount;
  };

  splitChildGoals = goals => {
    const returnObject = {};
    returnObject.leftData = [];
    returnObject.rightData = [];

    const orderedGoals = this.orderChildGoals(goals);

    const goalsReturn = orderedGoals.map(goal => {
      // track current count of goals for columns
      // each goal header currently counts for two metrics from a display perspective (which is what we're balancing for)
      const leftGoalCount = returnObject.leftData.length * 2;
      const rightGoalCount = returnObject.rightData.length * 2;

      // track current count of metrics/KRs for each goal on each side
      const leftMetricCount = this.calculateTotalMetricCount(
        returnObject.leftData
      );
      const rightMetricCount = this.calculateTotalMetricCount(
        returnObject.rightData
      );

      // total them up for effective visual weighting of l/r column elements
      const totalLeftCount = leftGoalCount + leftMetricCount;
      const totalRightCount = rightGoalCount + rightMetricCount;

      // if columns have same number of items, default to left column
      // or left has less items, add current item to left column
      if (
        totalLeftCount === totalRightCount ||
        totalLeftCount < totalRightCount
      ) {
        returnObject.leftData.push(goal);
        return goal;
      } else {
        // right has less items, add it to right column
        returnObject.rightData.push(goal);
        return goal;
      }
    });

    return returnObject;
  };

  orderChildGoals = goals => {
    // order child goals prior to splitting to ensure balance
    const orderedGoals = goals.sort((a, b) => {
      const aCount = a.metrics.length;
      const bCount = b.metrics.length;
      if (aCount > bCount) {
        return -1;
      } else if (bCount > aCount) {
        return 1;
      }
    });
    return orderedGoals;
  };

  displayTargetValue = (currentValue, targetValue) => {
    let returnContent = "";
    if (currentValue !== "--") {
      returnContent = ` of ${targetValue}`;
    }
    // console.log(`${currentValue}, ${targetValue}, ${returnContent}`);
    return returnContent;
  };

  render() {
    // detect old-school IE to apply an explicit style below
    let isLegacyIE = false;

    if (navigator.appVersion.indexOf('Trident/') > -1) {
      isLegacyIE = true;
    }

    // sets current data member context from the available data (controlled by left/right arrows)
    const currentData = this.props.slideData[this.props.refSrc === 'secondaryPage' ? 0 : this.props.currentSlideDataIndex];

    // rough heuristic for balancing top-level KRs in page header/subheader
    const subheaderMetricsLeft = this.getSubheaderMetricData(
      "left",
      currentData.metrics
    );
    const subheaderMetricsRight = this.getSubheaderMetricData(
      "right",
      currentData.metrics
    );

    // rough heuristic for balancing number of child goals on each side of body content
    // uses total KRs and KRs in each child body for balance calculation; does not preserve order left-right or top-down
    const totalChildGoalMetricCount = this.calculateTotalMetricCount(
      currentData.goals
    );
    const splitData = this.splitChildGoals(currentData.goals);

    return (
      <PortalModal>
        <div id="portalWrapper" className="portalWrapper">
          {this.displaySliderPrevArrow()}
          <div className={ isLegacyIE ? 'portalInner portalInnerLegacyIE' : 'portalInner'}>
            <div className="portalHeaderWrapper" id="portalHeaderWrapper">
              <div className="portalHeader" data-testid="portalHeader">
                <div className="portalHeaderTitle" data-testid="portalHeaderTitle">
                  <span className="portalHeaderTitleTeamname" data-testid="portalHeaderTitleTeamname">
                    {currentData.teamName === ""
                      ? currentData.ownerName
                      : currentData.teamName}
                  </span>
                  <br />
                  {currentData.goal}
                </div>
                <button className="portalClose" onClick={this.props.closeSlider}>
                  <span className="icon icon-outline-close-24px-white" />
                </button>
              </div>

              <div className="portalSubHeader">
                {/* subheader column1 (left) */}
                <div className="portalSubHeaderColumn">
                  {/* Loop through child goal KR rows for this column */}
                  {subheaderMetricsLeft.map((metric, index) => {
                    return (
                      <div
                        className="portalSubHeaderRow"
                        key={`${metric.goalId}${index}`}
                      >
                        <div className="portalSubHeaderLeftColumn">
                          <span style={{ color: metric.progressColor || metric.progress_color }}>
                            {metric.achieveTarget || metric.achieveTargetText}
                          </span>
                          {typeof metric.targetDisplay !== "undefined" &&
                          metric.targetDisplay
                            ? this.displayTargetValue(
                                metric.achieveTarget || metric.achieveTargetText,
                                metric.totalTarget || metric.totalTargetText
                              )
                            : ""}
                        </div>
                        <div data-testid="portalSubHeaderRightColumn" className="portalSubHeaderRightColumn">
                          {metric.name}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {/* subheader column2 (right) */}
                <div className="portalSubHeaderColumn">
                  {/* Loop through child goal KR rows for this column */}
                  {subheaderMetricsRight.map((metric, index) => {
                    return (
                      <div
                        className="portalSubHeaderRow"
                        key={`${metric.goalId}${index}`}
                      >
                        <div className="portalSubHeaderLeftColumn">
                          <span style={{ color: metric.progressColor || metric.progress_color }}>
                            {metric.achieveTarget || metric.achieveTargetText}
                          </span>
                          {typeof metric.targetDisplay !== "undefined" &&
                          metric.targetDisplay
                            ? this.displayTargetValue(
                              metric.achieveTarget || metric.achieveTargetText,
                              metric.totalTarget || metric.totalTargetText
                              )
                            : ""}
                        </div>
                        <div className="portalSubHeaderRightColumn" data-testid="portalSubHeaderRightColumn">
                          {metric.name}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div id="portalBody" className='portalBody'>
              {/* Column 1 (left) */}
              <div className="portalBodyColumnLeft">
                {/* Loop through child goals for column1 (left) */}
                {splitData.leftData.map((goal, index) => {
                  return (
                    <div className="portalBodyChildGoal" key={`${index}`}>
                      <div className="portalBodyChildGoalHeader">
                        <span className="portalBodyChildGoalHeaderTeamname">
                          {goal.teamName === ""
                            ? goal.ownerName
                            : goal.teamName}
                        </span>
                        <br />
                        <span className="portalBodyChildGoalHeaderGoalname">
                          {goal.goal}
                        </span>
                      </div>
                      <div className="portalBodyChildGoalBody">
                        {/* Loop through child goal KR rows */}
                        {goal.metrics.map((metric, index) => {
                          return (
                            <div
                              className="portalBodyChildGoalBodyRow"
                              key={`${index}`}
                            >
                              <div className="portalBodyChildGoalBodyLeftColumn">
                                <span style={{ color: metric.progressColor || metric.progress_color }}>
                                  {metric.achieveTarget || metric.achieveTargetText}
                                </span>
                                {typeof metric.targetDisplay !== "undefined" &&
                                metric.targetDisplay
                                  ? this.displayTargetValue(
                                    metric.achieveTarget || metric.achieveTargetText,
                                    metric.totalTarget || metric.totalTargetText
                                    )
                                  : ""}
                              </div>
                              <div className="portalBodyChildGoalBodyRightColumn">
                                {metric.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Column 2 (right) */}
              <div className="portalBodyColumnRight">
                {/* Loop through child goals for column2 (right) */}
                {splitData.rightData.map((goal, index) => {
                  return (
                    <div className="portalBodyChildGoal" key={`${index}`}>
                      <div className="portalBodyChildGoalHeader">
                        <span className="portalBodyChildGoalHeaderTeamname">
                          {goal.teamName === ""
                            ? goal.ownerName
                            : goal.teamName}
                        </span>
                        <br />
                        <span className="portalBodyChildGoalHeaderGoalname">
                          {goal.goal}
                        </span>
                      </div>
                      <div className="portalBodyChildGoalBody">
                        {/* Loop through child goal KR rows */}
                        {goal.metrics.map((metric, index) => {
                          return (
                            <div
                              className="portalBodyChildGoalBodyRow"
                              key={`${index}`}
                            >
                              <div className="portalBodyChildGoalBodyLeftColumn">
                                <span style={{ color: metric.progressColor || metric.progress_color }}>
                                  {metric.achieveTarget || metric.achieveTargetText}
                                </span>
                                {typeof metric.targetDisplay !== "undefined" &&
                                metric.targetDisplay
                                  ? this.displayTargetValue(
                                    metric.achieveTarget || metric.achieveTargetText,
                                    metric.totalTarget || metric.totalTargetText
                                    )
                                  : ""}
                              </div>
                              <div className="portalBodyChildGoalBodyRightColumn">
                                {metric.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {this.displaySliderNextArrow()}
        </div>
      </PortalModal>
    );
  }
}

export default AlignmentSlider;

const renderAlignmentSlider = (data) => {
  const mountId = document.getElementById('alignment-slider-mount');
  if (!data.shouldRender && mountId) {
    ReactDOM.unmountComponentAtNode(mountId);
    return null;
  }

  if (mountId) {
    ReactDOM.render(
      <AlignmentSlider {...data} />,
      mountId,
    );
  }
}

window.renderAlignmentSlider = renderAlignmentSlider;
